// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetPrototypeModuleOverviewRequestModel from '../../model/get-prototype-module-overview-request-model';
import GetPrototypeModuleOverviewRequestDTO from '../dto/get-prototype-module-overview-request-dto';
import dtoSchema from '../schemas/get-prototype-module-overview-request-schema';

export default abstract class GetPrototypeModuleOverviewRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetPrototypeModuleOverviewRequestDTO>) {
    super();
    if (data) {
      this.classId = data.classId;
      this.moduleId = data.moduleId;
      this.year = data.year;
    }
  }
  /**
  * @type {int64}
  */
  classId?: number;
  /**
  * @type {int64}
  */
  moduleId?: number;
  /**
  */
  year?: string;

  static toModel(dto: DeepPartial<GetPrototypeModuleOverviewRequestDTO>): GetPrototypeModuleOverviewRequestModel;
  static toModel(dto: DeepPartial<GetPrototypeModuleOverviewRequestDTO> | undefined | null): GetPrototypeModuleOverviewRequestModel | undefined;
  static toModel(dto: DeepPartial<GetPrototypeModuleOverviewRequestDTO> | undefined | null): GetPrototypeModuleOverviewRequestModel | undefined {
    return dto ? new GetPrototypeModuleOverviewRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetPrototypeModuleOverviewRequestModel> | GetPrototypeModuleOverviewRequestModel): GetPrototypeModuleOverviewRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      classId: unwrapped.classId,
      moduleId: unwrapped.moduleId,
      year: unwrapped.year,
    } as GetPrototypeModuleOverviewRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetPrototypeModuleOverviewRequestModel, can not map to GetPrototypeModuleOverviewRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
